/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgRegisterInfo.css";
import { simpleFetch } from "../../restWrapper";
import { AuthConsumer } from "../../AuthContext"; // Import AuthConsumer
//import { TwitterPicker,HuePicker } from 'react-color';
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import errorMsg from "../../assets/json/errMsg.json";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { PLATFORM, MAIN_DOMAIN } from "../../config";
import { validOrgInfo } from "../../assets/validators/organizations_orgInfo.js";

import "react-phone-number-input/style.css";
import PhoneInput, {
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

const SUBDOMAIN_CHECK_DEBOUNCE_MS = 400;

const RESERVED_SUBDOMAINS = new Set([
  "checkplus", "plug",
  "subdomain",
  "www", "api", "app", "admin", "mail",
  "login", "auth", "dashboard", "portal", "support", "help", "docs", "blog",
  "dev", "stage", "staging", "prod", "demo", "test",
]);

class OrgRegisterInfo extends Component {
  constructor(props) {
    super(props);
    try {
      // Read all incoming state, including plan details
      const incomingState = this.props.location.state || {};
      if (incomingState === null || !incomingState.username) {
        this.props.history.push("/OrgLogin");
      }
      this.state = {
        buttonClick: false,
        loading: false,
        // Store plan details in state
        planType: incomingState.planType,
        planDetails: incomingState.planDetails,
        // Initialize OrgRegisterInfo with data from state *and* defaults
        OrgRegisterInfo: {
          username: incomingState.username,
          directorName: incomingState.directorName,
          secretaryName: incomingState.secretaryName,
          // Default other fields
          password: "",
          firstName: "",
          lastName: "",
          phoneNumber: "",
          organizationName: "",
          subDomain: "",
          statementDescriptor: PLATFORM === "plug" ? "Plug" : "CheckPlus",
          buttonColor: "FFFFFF",
          headerColor: "2B91D6",
          progressBarColor: "2B91D6",
          organizationType: PLATFORM === "plug" ? "business" : "nonprofit",
        },
        language: this.props.language,
        confirmPw: "",
        confirmPwErr: "",
        testBtnColor: {
          background: "#2482C4",
        },
        errorMsg: {
          username: {
            msg: "",
          },
          organizationName: {
            msg: "",
          },
          statementDescriptor: {
            msg: "",
          },
          password: {
            msg: "",
          },
          subDomain: {
            msg: "",
          },
          firstName: {
            msg: "",
          },
          lastName: {
            msg: "",
          },
          phoneNumber: {
            msg: "",
          },
          buttonColor: {
            msg: "",
          },
          headerColor: {
            msg: "",
          },
          progressBarColor: {
            msg: "",
          },
          error: {
            msg: "",
          },
        },
        subDomainCheck: {
          status: "idle",
          value: "",
        },
        showPassword: false,
        showConfirmPassword: false,
      };
      this._subDomainDebounceTimer = null;
      this._subDomainCheckSeq = 0;
    } catch (e) {
      this.props.history.push("/OrgLogin");
    }

    this.handleUsername = this.handleUsername.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubDomain = this.handleSubDomain.bind(this);
    this.handleOrganizationName = this.handleOrganizationName.bind(this);
    this.handlepw = this.handlepw.bind(this);
    this.handleConfirmPw = this.handleConfirmPw.bind(this);
    this.handleSd = this.handleSd.bind(this);
    this.handleLastName = this.handleLastName.bind(this);
    this.handleFirstName = this.handleFirstName.bind(this);
    this.handlePhoneNumber = this.handlePhoneNumber.bind(this);
    this.setOrgRegisterInfoData = this.setOrgRegisterInfoData.bind(this);
    this.handleOrgButtonColor = this.handleOrgButtonColor.bind(this);
    this.handleOrgHeaderColor = this.handleOrgHeaderColor.bind(this);
    this.handleOrgBarColor = this.handleOrgBarColor.bind(this);
    // Remove binding for handleOrganizationTypeChange
  }

  componentDidMount() {
    const time = 1000 * 60 * 15;
    setTimeout(
      function () {
        this.props.history.push("/");
      }.bind(this),
      time,
    );
  }

  componentWillUnmount() {
    if (this._subDomainDebounceTimer) {
      clearTimeout(this._subDomainDebounceTimer);
      this._subDomainDebounceTimer = null;
    }
    this._subDomainCheckSeq++;
  }

  setOrgRegisterInfoData(s, name) {
    let data = this.state.OrgRegisterInfo;
    data[name] = s;
    let err = this.state.errorMsg;
    // Keep the { msg } shape. Assigning a bare "" here left errorMsg[name] a
    // string, and the next validation pass that wrote errorMsg[name].msg threw
    // instead of showing the error it had just worked out.
    err[name] = { msg: "" };
    this.setState({
      OrgRegisterInfo: data,
      errorMsg: err,
    });
  }

  handleOrgBarColor(color, e) {
    this.setOrgRegisterInfoData(color["hex"].substring(1), "progressBarColor");
  }

  handleOrgHeaderColor(color, e) {
    this.setOrgRegisterInfoData(color["hex"].substring(1), "headerColor");
  }

  handleOrgButtonColor(color, e) {
    this.setOrgRegisterInfoData(color["hex"].substring(1), "buttonColor");
  }

  handlePhoneNumber(e) {
    let i = e.target.value;
    let errStateMsg = this.state.errorMsg;
    if (isNaN(i)) {
      var err = errorMsg[this.state.language].orgInfoErr;
      errStateMsg.phoneNumber["msg"] = err.phoneNumberErr;
      this.setState({
        errorMsg: errStateMsg,
      });
      return false;
    }
    if (i.length > 8) {
      return false;
    }
    this.setOrgRegisterInfoData(e.target.value, "phoneNumber");
  }

  handleFirstName(e) {
    let i = e.target.value;
    var hasNumber = /\d/;
    if (hasNumber.test(i)) {
      return false;
    }
    this.setOrgRegisterInfoData(e.target.value, "firstName");
  }

  handleLastName(e) {
    let i = e.target.value;
    var hasNumber = /\d/;
    if (hasNumber.test(i)) {
      return false;
    }
    this.setOrgRegisterInfoData(e.target.value, "lastName");
  }

  handlepw(e) {
    this.setOrgRegisterInfoData(e.target.value, "password");
  }

  handleSd(e) {
    this.setOrgRegisterInfoData(e.target.value, "statementDescriptor");
  }

  handleConfirmPw(e) {
    this.setState({
      confirmPw: e.target.value,
    });
  }

  handleOrganizationName(e) {
    this.setOrgRegisterInfoData(e.target.value, "organizationName");
  }

  handleUsername(e) {
    this.setOrgRegisterInfoData(e.target.value, "username");
  }

  handleSubDomain(e) {
    const text = e.target.value;
    var letters = /^[a-zA-Z0-9]+$/;
    if (!text.match(letters)) {
      if (text !== "") return false;
    }
    this.setOrgRegisterInfoData(text, "subDomain");
    this.scheduleSubDomainCheck(text);
  }

  scheduleSubDomainCheck(rawValue) {
    if (this._subDomainDebounceTimer) {
      clearTimeout(this._subDomainDebounceTimer);
      this._subDomainDebounceTimer = null;
    }

    const value = (rawValue || "").trim().toLowerCase();

    if (!value) {
      this.setState({
        subDomainCheck: { status: "idle", value: "" },
      });
      return;
    }

    if (RESERVED_SUBDOMAINS.has(value)) {
      this.setState({ subDomainCheck: { status: "reserved", value } });
      return;
    }

    this.setState({
      subDomainCheck: { status: "checking", value },
    });

    this._subDomainDebounceTimer = setTimeout(() => {
      this._subDomainDebounceTimer = null;
      this.checkSubDomainAvailability(value);
    }, SUBDOMAIN_CHECK_DEBOUNCE_MS);
  }

  checkSubDomainAvailability(value) {
    const seq = ++this._subDomainCheckSeq;
    simpleFetch("/organizations/subdomain-availability", "GET", {
      subDomain: value,
    }).then((res) => {
      if (seq !== this._subDomainCheckSeq) return;
      const currentValue = (
        this.state.OrgRegisterInfo.subDomain || ""
      )
        .trim()
        .toLowerCase();
      if (currentValue !== value) return;

      if (res && res.status === 200 && res.body) {
        this.setState({
          subDomainCheck: {
            status: res.body.available ? "available" : "taken",
            value,
          },
        });
      } else {
        // simpleFetch resolves to an Error object on a network failure, so
        // res.status is undefined here for a dead backend, a 429 or a CORS
        // rejection. Falling back to "idle" rendered nothing at all and left
        // the submit button inert with no explanation.
        this.setState({
          subDomainCheck: { status: "error", value },
        });
      }
    });
  }

  // Remove handleOrganizationTypeChange function

  /**
   * Collect a message for every condition that keeps the form from
   * submitting.
   *
   * Mirrors isFormValid in render(), and the two have to stay in step: if this
   * misses a condition the button is inert with nothing explaining why, and if
   * it adds one the form reports an error the gate does not actually check.
   *
   * @return {Object} { errors, confirmPwErr }
   */
  getValidationErrors() {
    const orgInfo = this.state.OrgRegisterInfo;
    const err = errorMsg[this.state.language].orgInfoErr;
    const fieldErr = errorMsg[this.state.language].OrgRegisterInfo;
    const pwErr = errorMsg[this.state.language].pwErr;
    const errors = {};

    if (!orgInfo.organizationName) {
      errors.organizationName = err.orgNameErr;
    }

    if (!orgInfo.subDomain) {
      errors.subDomain = err.subDomainErr;
    } else if (this.state.subDomainCheck.status !== "available") {
      switch (this.state.subDomainCheck.status) {
        case "taken":
          errors.subDomain = fieldErr.subDomainExist;
          break;
        case "reserved":
          errors.subDomain = fieldErr.subDomainReserved;
          break;
        case "checking":
          errors.subDomain = fieldErr.subDomainNotVerified;
          break;
        default:
          // "idle" or "error" — the availability check never returned an answer
          errors.subDomain = fieldErr.subDomainCheckFailed;
      }
    }

    if (!isValidPhoneNumber(orgInfo.phoneNumber || "")) {
      errors.phoneNumber = err.phoneNumberErr;
    }

    if (!orgInfo.lastName) {
      errors.lastName = err.lastNameErr;
    }

    if (!orgInfo.firstName) {
      errors.firstName = err.firstNameErr;
    }

    if (!orgInfo.password) {
      errors.password = pwErr.passwordRequiredErr;
    } else if (orgInfo.password !== orgInfo.password.trim()) {
      errors.password = pwErr.passwordSpaceErr;
    }

    let confirmPwErr = "";
    if (!this.state.confirmPw) {
      confirmPwErr = pwErr.confirmPwRequiredErr;
    } else if (this.state.confirmPw !== orgInfo.password) {
      confirmPwErr = pwErr.reEnterPwErr;
    }

    return { errors, confirmPwErr };
  }

  /**
   * Paint the validation errors onto the form.
   *
   * Every errorMsg entry is rebuilt rather than merged, so a field the person
   * has since fixed loses its message too — otherwise a corrected field keeps
   * showing the stale reason it was wrong.
   */
  showValidationErrors() {
    const { errors, confirmPwErr } = this.getValidationErrors();
    const fieldErr = errorMsg[this.state.language].OrgRegisterInfo;
    const nextErrorMsg = {};
    for (const key of Object.keys(this.state.errorMsg)) {
      nextErrorMsg[key] = { msg: errors[key] || "" };
    }
    nextErrorMsg.error = { msg: fieldErr.formIncomplete };

    this.setState({
      errorMsg: nextErrorMsg,
      confirmPwErr: confirmPwErr,
      buttonClick: true,
    });
  }

  handleSubmit(e) {
    // console.log("handleSubmit triggered"); // Log start - REMOVED
    this.setState({
      buttonClick: true,
    });

    if (this.state.loading) {
      // console.log("Exiting: Already loading"); // Log exit - REMOVED
      return null;
    }

    // console.log("Setting loading: true"); // Log state change - REMOVED
    this.setState({
      loading: true,
    });
    const err = errorMsg[this.state.language].orgInfoErr;
    let errStateMsg = this.state.errorMsg;
    // Removed duplicate const orgInfo declaration here
    const orgInfo = this.state.OrgRegisterInfo; // Keep original declaration
    // console.log("Checking SD:", orgInfo.statementDescriptor); // Log validation - REMOVED SD VALIDATION - REMOVED
    // let checkInputSd = validOrgInfo.checkSD(orgInfo.statementDescriptor); // REMOVED SD VALIDATION - REMOVED
    // if (!checkInputSd) { // REMOVED SD VALIDATION - REMOVED
    //   console.log("Validation Failed: SD"); // Log failure - REMOVED SD VALIDATION - REMOVED
    //   const msg = err.statementDescriptor; // REMOVED SD VALIDATION - REMOVED
    //   errStateMsg.statementDescriptor = {}; // REMOVED SD VALIDATION
    //   errStateMsg.statementDescriptor.msg = msg; // REMOVED SD VALIDATION
    //   this.setState({ // REMOVED SD VALIDATION
    //     errorMsg: errStateMsg, // REMOVED SD VALIDATION
    //     loading: false, // REMOVED SD VALIDATION
    //   }); // REMOVED SD VALIDATION
    //   return false; // REMOVED SD VALIDATION
    // } // REMOVED SD VALIDATION - REMOVED

    // console.log("Checking Phone Number:", orgInfo.phoneNumber); // Log validation - REMOVED
    if (!isValidPhoneNumber(orgInfo.phoneNumber || "")) {
      // Add default empty string to prevent error if undefined
      // console.log("Validation Failed: Phone Number"); // Log failure - REMOVED
      errStateMsg.phoneNumber.msg = err.phoneNumberErr;
      this.setState({
        errorMsg: errStateMsg,
        loading: false,
      });
      return false;
    }

    // console.log("Checking Password Confirmation"); // Log validation - REMOVED
    if (orgInfo.password !== orgInfo.password.trim()) {
      errStateMsg.password.msg = errorMsg[this.state.language].pwErr.passwordSpaceErr;
      this.setState({ errorMsg: errStateMsg, loading: false });
      return false;
    }

    if (this.state.confirmPw !== orgInfo.password) {
      // console.log("Validation Failed: Password Confirmation"); // Log failure - REMOVED
      const err = errorMsg[this.state.language].pwErr;

      this.setState({
        confirmPwErr: err.reEnterPwErr,
        loading: false,
      });
      return false;
    } else {
      // console.log("Password Confirmation OK"); // Log success - REMOVED
      this.setState({
        confirmPwErr: "",
      });
    }

    let params = {
      ...this.state.OrgRegisterInfo, // Include all form fields
      language: this.state.language,
      planType: this.state.planType, // Add planType
      planDetails: this.state.planDetails, // Add planDetails (will be null/undefined for 'free')
    };

    // console.log("Validation Passed. Making API call with params:", params); // Log API call start
    simpleFetch("/organizations/register", "POST", params).then((res) => {
      // console.log("API call finished. Status:", res.status); // Log API result
      this.setState({
        loading: false,
      });
      if (res.status === 204) {
        // console.log("API Success (204). Redirecting..."); // Log redirect - REMOVED
        this.props.history.push({
          pathname: "/OrgConfirm",
        });
      } else {
        this.setState({
          buttonClick: false,
        });

        if (res.body.errors) {
          const msg = res.body.errors;

          if (msg) {
            const errPwMsg = errorMsg[this.state.language].pwErr.passwdErr;
            const errObj = errorMsg[this.state.language].OrgRegisterInfo;
            Object.keys(msg).forEach(function (key) {
              switch (key) {
                case "password":
                  errStateMsg["password"].msg = errPwMsg;
                  break;
                default:
                  errStateMsg[key].msg = errObj[key];
              }
            });
          }
          this.setState({
            errorMsg: errStateMsg,
          });
        } else {
          errStateMsg = {
            username: {
              msg: "",
            },
            organizationName: {
              msg: "",
            },
            password: {
              msg: "",
            },
            subDomain: {
              msg: "",
            },
            firstName: {
              msg: "",
            },
            lastName: {
              msg: "",
            },
            phoneNumber: {
              msg: "",
            },
            buttonColor: {
              msg: "",
            },
            headerColor: {
              msg: "",
            },
            progressBarColor: {
              msg: "",
            },
            error: {
              msg: "",
            },
          };
        }
      }
      if (res.status === 422) {
        // Subdomain already exists
        const errObj = errorMsg[this.state.language].OrgRegisterInfo;
        errStateMsg["subDomain"].msg = errObj.subDomainExist;
        this.setState({
          errorMsg: errStateMsg,
        });
      }
      if (res.status === 500) {
        errStateMsg.error.msg = errorMsg[this.state.language].fail;
      }
      this.setState({
        errorMsg: errStateMsg,
      });
    });
  }

  errRender(errStr) {
    if (!errStr) return;
    return <div>{renderErrorMsg(errStr)}</div>;
  }

  renderPasswordGuidance(languageObj) {
    const pw = this.state.OrgRegisterInfo.password;
    if (!pw || this.state.errorMsg.password.msg) return null;
    const has8 = pw.length >= 8;
    const has12 = pw.length >= 12;
    const hasSpace = pw !== pw.trim();
    return (
      <div className="OrgRegisterInfo-pwGuidance">
        <div className={"OrgRegisterInfo-pwHint" + (has8 ? " OrgRegisterInfo-pwHint-met" : "")}>
          {has8 ? "✓" : "·"} {languageObj.passwordHint8}
        </div>
        <div className={"OrgRegisterInfo-pwHint" + (has12 ? " OrgRegisterInfo-pwHint-met" : "")}>
          {has12 ? "✓" : "·"} {languageObj.passwordHint12}
        </div>
        {hasSpace && (
          <div className="OrgRegisterInfo-pwHint OrgRegisterInfo-pwHint-warn">
            {errorMsg[this.state.language].pwErr.passwordSpaceErr}
          </div>
        )}
      </div>
    );
  }

  renderSubDomainStatus(languageObj) {
    const { status, value } = this.state.subDomainCheck;
    if (this.state.errorMsg.subDomain.msg) return null;
    const currentValue = (this.state.OrgRegisterInfo.subDomain || "")
      .trim()
      .toLowerCase();
    if (!currentValue || currentValue !== value) return null;

    if (status === "checking") {
      return (
        <div className="OrgRegisterInfo-subDomainStatus OrgRegisterInfo-subDomainStatus-checking">
          {languageObj.subDomainChecking}
        </div>
      );
    }
    if (status === "available") {
      return (
        <div className="OrgRegisterInfo-subDomainStatus OrgRegisterInfo-subDomainStatus-available">
          {languageObj.subDomainAvailable}
        </div>
      );
    }
    if (status === "taken") {
      const takenMsg =
        errorMsg[this.state.language].OrgRegisterInfo.subDomainExist;
      return renderErrorMsg(takenMsg);
    }
    if (status === "reserved") {
      const reservedMsg =
        errorMsg[this.state.language].OrgRegisterInfo.subDomainReserved;
      return renderErrorMsg(reservedMsg);
    }
    if (status === "error") {
      const failedMsg =
        errorMsg[this.state.language].OrgRegisterInfo.subDomainCheckFailed;
      return renderErrorMsg(failedMsg);
    }
    return null;
  }
  render() {
    // Determine logo class based on platform
    const logoClassName =
      PLATFORM === "plug"
        ? "OrgRegisterInfo-PlugLogo"
        : "OrgRegisterInfo-CheckPlusLogo";

    if (
      this.props.location.state === null ||
      this.props.location.state === undefined ||
      this.state.loading
    ) {
      return (
        <div className="OrgRegisterInfo-view">
          <div className="OrgRegisterInfo-loadingPrompt">
            <this.props.RenderFullPageLoading />
          </div>
        </div>
      );
    }
    const languageObj = this.props.languageObj;
    const subD = this.state.OrgRegisterInfo.subDomain;
    const subDomainText =
      languageObj.subDomainText +
      (subD === ""
        ? " (YourSubDomain." + MAIN_DOMAIN + ")"
        : " (" + subD + "." + MAIN_DOMAIN + ")");

    const orgInfo = this.state.OrgRegisterInfo;
    const isFormValid =
      !!orgInfo.organizationName &&
      !!orgInfo.subDomain &&
      this.state.subDomainCheck.status === "available" &&
      isValidPhoneNumber(orgInfo.phoneNumber || "") &&
      !!orgInfo.firstName &&
      !!orgInfo.lastName &&
      !!orgInfo.password &&
      orgInfo.password === orgInfo.password.trim() &&
      !!this.state.confirmPw &&
      this.state.confirmPw === orgInfo.password;

    const onSubmitClick = (e) => {
      if (!isFormValid) {
        this.showValidationErrors();
        return;
      }
      const isConfirm = window.confirm(languageObj.confirmBtn + "?");
      if (isConfirm) this.handleSubmit(e);
    };

    const handleKeyDown = (event) => {
      if (event.key === "Enter" && isFormValid) {
        this.handleSubmit();
      }
    };

    return (
      <div className="OrgRegisterInfo-view">
        <div className="OrgRegisterInfo-header">
          {/* Use dynamic logo class */}
          <div className={logoClassName} />
          <div className="OrgAgreement-headerBottom">
            <Link to={"/"}>
              <div className="OrgRegisterInfo-backContainer">
                <div className="OrgRegisterInfo-backBtn" />
              </div>
            </Link>

            <div className="OrgRegisterInfo-loginText">
              {languageObj.loginText}
            </div>
            <div className="OrgRegisterInfo-clickContainer">
              <div className="OrgRegisterInfo-clickIcn"></div>
              <div className="OrgRegisterInfo-clickTxt">
                {languageObj.click}
              </div>
            </div>

            <div
              onClick={onSubmitClick}
              className={
                "OrgRegisterInfo-nextBtn" +
                (isFormValid ? "" : " OrgRegisterInfo-nextBtn-disabled")
              }
              aria-disabled={!isFormValid}
            >
              <div className="OrgRegisterInfo-nextIcn" />
            </div>
          </div>
        </div>

        <div className="OrgRegisterInfo-bigContainer">
          <div className="OrgRegisterInfo-firstContainer">
            <div className="OrgRegisterInfo-textFieldGroup">
              <div className="OrgRegisterInfo-subheading">
                {languageObj.subheading[1]}
              </div>

              <div className="OrgRegisterInfo-inputFieldContainerDisabled">
                <input
                  type="text"
                  className="OrgRegisterInfo-inputFieldDisabled"
                  value={this.state.OrgRegisterInfo.username}
                  onChange={this.handleUsername}
                  placeholder={languageObj.inputField[2]}
                  disabled
                />
              </div>
              {this.errRender(this.state.errorMsg.username.msg)}
            </div>

            <div className="OrgRegisterInfo-textFieldGroup">
              <div className="OrgRegisterInfo-subheading">
                {languageObj.subheading[0]}
              </div>

              <div className="OrgRegisterInfo-inputFieldContainer">
                <input
                  type="text"
                  className="OrgRegisterInfo-inputField"
                  value={this.state.OrgRegisterInfo.organizationName}
                  onChange={this.handleOrganizationName}
                  placeholder={languageObj.inputField[0]}
                />
              </div>

              {this.errRender(this.state.errorMsg.organizationName.msg)}
            </div>

            <div className="OrgRegisterInfo-textFieldGroup">
              <div className="OrgRegisterInfo-subheading">{subDomainText}</div>

              <div className="OrgRegisterInfo-inputFieldContainer">
                <input
                  type="text"
                  className="OrgRegisterInfo-inputField"
                  value={this.state.OrgRegisterInfo.subDomain}
                  onChange={this.handleSubDomain}
                  placeholder={languageObj.inputField[1]}
                />
              </div>
              {this.errRender(this.state.errorMsg.subDomain.msg)}
              {this.renderSubDomainStatus(languageObj)}
            </div>

            <div className="OrgRegisterInfo-textFieldGroup">
              <div className="OrgRegisterInfo-subheading">
                {languageObj.subheading[4]}
              </div>

              <div className="OrgRegisterInfo-inputFieldContainer">
                <PhoneInput
                  className="OrgRegisterInfo-inputField"
                  placeholder={languageObj.inputField[5]}
                  value={this.state.OrgRegisterInfo.phoneNumber}
                  defaultCountry={"HK"}
                  flags={flags}
                  onChange={(phone) => {
                    let obj = this.state.OrgRegisterInfo;
                    const no = formatPhoneNumberIntl(phone);
                    obj.phoneNumber = no;
                    let errorMsg = this.state.errorMsg;
                    errorMsg.phoneNumber = "";
                    this.setState({
                      OrgRegisterInfo: obj,
                      errorMsg: errorMsg,
                    });
                  }}
                />
              </div>
              {this.errRender(this.state.errorMsg.phoneNumber.msg)}
            </div>

            {/* Removed Segmented Control for Organization Type Selection */}
          </div>

          <div className="OrgRegisterInfo-secondContainer">
            <div className="OrgRegisterInfo-firstLastNameGroup">
              <div className="OrgRegisterInfo-textFieldLastNameGroup">
                <div className="OrgRegisterInfo-subheading">
                  {languageObj.subheading[2]}
                </div>

                <div className="OrgRegisterInfo-inputFieldLastNameContainer">
                  <input
                    type="text"
                    className="OrgRegisterInfo-inputFieldLastName"
                    value={this.state.OrgRegisterInfo.lastName}
                    onChange={this.handleLastName}
                    placeholder={languageObj.inputField[3]}
                  />
                </div>
              </div>

              <div className="OrgRegisterInfo-textFieldFirstNameGroup">
                <div className="OrgRegisterInfo-subheading">
                  {languageObj.subheading[3]}
                </div>

                <div className="OrgRegisterInfo-inputFieldFirstNameContainer">
                  <input
                    type="text"
                    className="OrgRegisterInfo-inputFieldFirstName"
                    value={this.state.OrgRegisterInfo.firstName}
                    onChange={this.handleFirstName}
                    placeholder={languageObj.inputField[4]}
                  />
                </div>
              </div>

              {this.errRender(this.state.errorMsg.lastName.msg)}
              {this.errRender(this.state.errorMsg.firstName.msg)}
            </div>

            <div className="OrgRegisterInfo-textFieldGroup">
              <div className="OrgRegisterInfo-subheading">
                {languageObj.subheading[5]}
              </div>

              <div className="OrgRegisterInfo-inputFieldContainer OrgRegisterInfo-inputFieldContainer-pw">
                <input
                  type={this.state.showPassword ? "text" : "password"}
                  className="OrgRegisterInfo-inputField OrgRegisterInfo-inputField-pw"
                  value={this.state.OrgRegisterInfo.password}
                  onChange={this.handlepw}
                  placeholder={languageObj.inputField[6]}
                  maxLength={64}
                />
                <button
                  type="button"
                  className="OrgRegisterInfo-pwToggle"
                  onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                >
                  {this.state.showPassword ? languageObj.passwordHide : languageObj.passwordShow}
                </button>
              </div>
              {this.errRender(this.state.errorMsg.password.msg)}
              {this.renderPasswordGuidance(languageObj)}
            </div>

            <div className="OrgRegisterInfo-textFieldGroup">
              <div className="OrgRegisterInfo-subheading">
                {languageObj.subheading[6]}
              </div>

              <div className="OrgRegisterInfo-inputFieldContainer OrgRegisterInfo-inputFieldContainer-pw">
                <input
                  type={this.state.showConfirmPassword ? "text" : "password"}
                  className="OrgRegisterInfo-inputField OrgRegisterInfo-inputField-pw"
                  value={this.state.confirmPw}
                  onChange={this.handleConfirmPw}
                  placeholder={languageObj.inputField[7]}
                  onKeyDown={handleKeyDown}
                  maxLength={64}
                />
                <button
                  type="button"
                  className="OrgRegisterInfo-pwToggle"
                  onClick={() => this.setState({ showConfirmPassword: !this.state.showConfirmPassword })}
                >
                  {this.state.showConfirmPassword ? languageObj.passwordHide : languageObj.passwordShow}
                </button>
              </div>

              {this.errRender(this.state.confirmPwErr)}

              {this.errRender(this.state.errorMsg.error.msg)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
OrgRegisterInfo.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};
export default OrgRegisterInfo;
